import React from 'react';

import './TopNavigationBarItem.css';
import { Link } from 'react-router-dom';

type TopNavigationBarItemProps = {
    isActive?: boolean,
    text: string,
    link: string,
    iconClassName?: string,
    handleClick: any,
    id: string
}

export const TopNavigationBarItem = (props: TopNavigationBarItemProps) => {

    let liClassName = props.isActive ? 'nav-item active' : 'nav-item';

    return <>
        {props.iconClassName && <i style={{ paddingTop: '10px', paddingLeft: '10px' }} className={props.iconClassName}></i>}
        <li className={liClassName}>
            <Link to={props.link}>
                <a className="nav-link waves-effect" onClick={() => props.handleClick(props.id)}>{props.text}</a>
            </Link>
        </li>
    </>
}